import { Button } from "@material-ui/core"
import * as React from "react"

function MCHero(props) {

    return (<div style={{backgroundColor: '#ED5D57'}} className="h-64 mt-20 flex flex-row place-content-center items-center mb-20">
                    <img src={props.image} alt="{props.name} hero"/>
            </div>)
}

export default MCHero